import React, {useEffect, useState} from 'react';
import Dialog from "components/Dialog";
import {makeStyles, Typography} from "@material-ui/core";
import Tr from "translations/Translations";
import Loading from "components/Loading";
import SingleButton from "components/popup/components/SingleButton";
import EmailListService from "services/EmailListService";
import BoldTypography from "components/BoldTypography";
import clsx from "clsx";
import EmailDeliveriesTable from "./EmailDeliveriesTable";


const useStyle = makeStyles((theme) => ({
    secContent: {
        paddingBottom: theme.spacing(2)
    },
    preLine: {
        whiteSpace: "pre-line"
    },
    previewBox: {
        width: '98%',
        overflow: 'auto',
        border: `solid 1px ${theme.palette.primary.main}`,
    },
    previewHtml: {
        height: 300,
    },
    previewNoHtml: {
        maxHeight: 300,
        whiteSpace: "pre-line",
        padding: theme.spacing(),
        paddingRight: 0
    }
}));

const EmailDetailsPopup = (
    {
        demandId,
        emailId,
        detailed,
        onClose = () => {
        }
    }) => {

    const classes = useStyle({});

    const [emailDetails, setEmailDetails] = useState(null);

    useEffect(() => {
        EmailListService.getEmailDetails(demandId, emailId).then((resp) => setEmailDetails(resp));
    }, [demandId, emailId])


    return (
        <Dialog
            title={Tr('email_details')}
            open
            titleCentered
            maxWidth={'md'}
            fullWidth={true}
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr('close')}
                onClick={onClose}
            />}
        >

            {!emailDetails && <Loading/>}

            {!!emailDetails && <>

                {detailed && <>
                    <BoldTypography>{Tr('sender')}:</BoldTypography>
                    <Typography className={classes.secContent}>
                        {emailDetails.from}
                    </Typography>


                    {!!emailDetails?.to.length && <>
                        <BoldTypography>{Tr('email_to')}:</BoldTypography>
                        <Typography className={clsx(classes.secContent, classes.preLine)}>
                            {emailDetails.to.join('\n')}
                        </Typography></>
                    }
                    {!!emailDetails?.cc.length && <>
                        <BoldTypography>{Tr('email_cc')}:</BoldTypography>
                        <Typography className={clsx(classes.secContent, classes.preLine)}>
                            {emailDetails.cc.join('\n')}
                        </Typography></>
                    }
                    {!!emailDetails?.bcc.length && <>
                        <BoldTypography>{Tr('email_bcc')}:</BoldTypography>
                        <Typography className={clsx(classes.secContent, classes.preLine)}>
                            {emailDetails.bcc.join('\n')}
                        </Typography></>
                    }
                </>}
                <BoldTypography>{Tr('subject')}:</BoldTypography>
                <Typography className={classes.secContent}>
                    {emailDetails.subject}
                </Typography>

                {detailed && <>
                    <BoldTypography>{Tr('email_content')}:</BoldTypography>
                    <Typography component='div' className={classes.secContent}>
                        {
                            emailDetails.html ? <iframe title={Tr('email_content')} className={clsx(classes.previewBox, classes.previewHtml)}
                                                        srcDoc={emailDetails.message}/>
                                : <Typography component='div' className={clsx(classes.previewBox, classes.previewNoHtml)}>{emailDetails.message}</Typography>
                        }
                    </Typography>

                    <BoldTypography>{Tr('attachments')}:</BoldTypography>
                    <Typography className={classes.secContent}>
                        --
                    </Typography>
                </>}

                {!!emailDetails?.deliveries && <>
                    <BoldTypography>{Tr('send_status')}:</BoldTypography>
                    <EmailDeliveriesTable deliveryList={emailDetails.deliveries}/>
                </>
                }


            </>}
        </Dialog>
    );
}


EmailDetailsPopup.propTypes = {};

export default EmailDetailsPopup;